import React from "react";
import { decIt, eurIt, itText } from "@/lib/itFormat";

const range = (r) => (!r ? null : Math.round(r.low) === Math.round(r.high) ? eurIt(r.low) : `${eurIt(r.low)} – ${eurIt(r.high)}`);
const years = (lo, hi) => (lo == null ? null : lo === hi || hi == null ? decIt(lo) : `${decIt(lo)}–${decIt(hi)}`);

const Row = ({ label, value }) =>
  value ? (
    <div className="flex justify-between gap-4 text-sm py-1 border-b border-gray-100 last:border-0">
      <span className="text-gray-500">{label}</span>
      <span className="font-semibold text-[#0A0A0A] text-right whitespace-nowrap">{value}</span>
    </div>
  ) : null;

export const StrategyFigures = ({ card }) => {
  const e = card?.economic_analysis || {};
  return (
    <div className="rounded-xl bg-[#FAFAFA] border border-gray-100 p-4" data-testid={`pa-result-card-${card?.scenario_key}`}>
      <div className="flex items-center justify-between gap-2 mb-2">
        <p className="font-bold text-[#0A0A0A]">{card?.title}</p>
        {card?.score != null && <span className="text-xs font-bold px-2 py-0.5 rounded-full bg-white border border-gray-200">{card.score}/100</span>}
      </div>
      <Row label="Ricavo netto stimato" value={range(e.net_proceeds_range)} />
      <Row label="Canone netto annuo" value={range(e.annual_net_rent_range)} />
      <Row label="Investimento iniziale" value={range(e.upfront_costs_range)} />
      <Row label="Rientro (anni)" value={years(e.payback_years_low, e.payback_years_high)} />
      {card?.score_rationale && <p className="text-xs text-gray-500 mt-2" data-testid={`pa-result-rationale-${card?.scenario_key}`}>{itText(card.score_rationale)}</p>}
    </div>
  );
};

const Insight = ({ insight, id }) => (
  <div className="border-l-2 border-[#B40101] pl-4 space-y-2" data-testid={`pa-result-insight-${id}`} data-source={insight.source}>
    <p className="text-xs uppercase tracking-wider text-gray-500 font-bold">Cosa emerge dall'analisi</p>
    <p className="text-sm text-[#0A0A0A] leading-relaxed">{itText(insight.text)}</p>
    {insight.checks?.length > 0 && (
      <>
      <p className="text-xs uppercase tracking-wider text-gray-500 font-bold pt-1">Cosa verificare prima di procedere</p>
      <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1" data-testid={`pa-result-checks-${id}`}>
        {insight.checks.map((c) => <li key={c.key}>{itText(c.text)}</li>)}
      </ul>
      </>
    )}
  </div>
);

export const PaResultBody = ({ item }) => {
  const p = item.payload || {};
  if (item.kind === "compare") {
    return (
      <div className="space-y-3">
        <div className="grid md:grid-cols-2 gap-3">{(p.cards || []).map((c) => <StrategyFigures key={c.scenario_key} card={c} />)}</div>
        {p.synthesis && <p className="text-sm text-gray-700 whitespace-pre-wrap" data-testid={`pa-result-synthesis-${item.analysis_id}`}>{itText(p.synthesis)}</p>}
      </div>
    );
  }
  return (
    <div className="space-y-3">
      {p.origin?.title && (
        <p className="text-xs text-gray-500" data-testid={`pa-result-origin-${item.analysis_id}`}>
          Strategia di origine: <strong>{p.origin.title}</strong> · DECIDI del proprietario v{p.origin.decision_version}
        </p>
      )}
      {p.insight && <Insight insight={p.insight} id={item.analysis_id} />}
      <StrategyFigures card={p.card} />
    </div>
  );
};
